export class WritingSounds {
  public static INTRO: { [id: string]: string } = {
    'can you write a letter': require('../../sounds/writing/can you write a letter.mp3')
  }

  public static NUBMER: { [id: string]: string } = {
    'can you write a number': require('../../sounds/writing/can you write a number.mp3')
  }
}
